type ScheduleIdle = (task: () => void) => void;

// requestIdleCallback is missing in Safari; a delayed timeout keeps the
// prefetch off the critical path there too.
const scheduleWhenIdle: ScheduleIdle = (task) => {
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(() => task());
  } else {
    window.setTimeout(task, 2000);
  }
};

export const prefetchChat = (
  loadChat: () => Promise<unknown> = () => import("./views/ChatView.vue"),
  scheduleIdle: ScheduleIdle = scheduleWhenIdle
): void => {
  scheduleIdle(() => {
    loadChat().catch(() => undefined);
  });
};
